export const validateIsEmail = (email: string) => {
  if (!email?.trim()?.length) return false

  return email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
}
